import { marked } from "marked";
import { functions } from "@/store/libs/appwrite";

const state = {
  loading: false,
  conversation: [],
  error: null,
  iaStreaming: false,
  summary: null,
};

const getters = {
  iaLoading: (state) => state.loading,
  iaConversation: (state) => state.conversation,
  iaError: (state) => state.error,
  iaStreaming: (state) => state.iaStreaming,
};

const actions = {
  async sendIaMessage({ commit, state, dispatch }, userMessage) {
    try {
      commit("setLoading", true);
      commit("setError", null);
      commit("addMessage", { role: "user", content: userMessage });
      commit("addMessage", { role: "assistant", content: "" });

      const history = state.conversation
        .filter((m) => m.role === "user" || m.role === "assistant")
        .slice(-5);

      const payload = {
        text: userMessage,
        history,
        summary: state.summary,
        mode: "chat",
      };

      const execution = await functions.createExecution(
        "sun-i",
        JSON.stringify({ data: JSON.stringify(payload) }),
        false
      );

      const result = JSON.parse(execution.responseBody);

      const fullAnswer = result?.message;

      if (!fullAnswer || typeof fullAnswer !== "string") {
        throw new Error("Réponse IA vide ou invalide");
      }

      let partialRaw = "";
      commit("setStreaming", true);
      commit("setLoading", false);

      for (let i = 0; i < fullAnswer.length; i++) {
        partialRaw += fullAnswer[i];
        const partialHTML = marked(partialRaw);
        commit("updateLastAssistantMessage", partialHTML);
        await new Promise((r) => setTimeout(r, 30));
      }

      commit("setStreaming", false);

      dispatch("updateSummary");
    } catch (err) {
      console.error("🔥 Erreur Appwrite Function :", err);
      commit("setError", err.message || "Erreur inconnue");
    } finally {
      commit("setLoading", false);
    }
  },

  async updateSummary({ commit, state }) {
    try {
      const shortHistory = state.conversation
        .filter((m) => m.role === "user" || m.role === "assistant")
        .slice(-12);

      const payload = {
        text: "Résumé de conversation",
        history: shortHistory,
        summary: null,
        mode: "summary",
      };

      const execution = await functions.createExecution(
        "sun-i",
        JSON.stringify({ data: JSON.stringify(payload) }),
        false
      );

      const result = JSON.parse(execution.responseBody);
      const summary = result?.message;

      if (summary) {
        commit("setSummary", summary);
      }
    } catch (err) {
      console.warn("⚠️ Erreur résumé :", err.message);
    }
  },
};

const mutations = {
  setLoading(state, value) {
    state.loading = value;
  },
  setError(state, value) {
    state.error = value;
  },
  addMessage(state, message) {
    state.conversation.push(message);
  },
  updateLastAssistantMessage(state, newContent) {
    const last = state.conversation[state.conversation.length - 1];
    if (last?.role === "assistant") {
      last.content = newContent;
    }
  },
  setStreaming(state, value) {
    state.iaStreaming = value;
  },
  setSummary(state, summary) {
    state.summary = summary;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
